/**
 * Envío AP-14 · «Adaptar video»: ajustes por destino y estimación de peso.
 */
export const VIDEO_PRESETS = [
  { key: 'dreamActor', label: 'Para Dream Actor', hint: '3–30 s · 720p · hasta 28 MB', minSec: 3, maxSec: 30, height: 720, fps: 30, maxMB: 28, audio: false },
  { key: 'videoWithSound', label: 'Para Video con sonido', hint: 'Hasta 8,7 s · 720p', minSec: 1, maxSec: 8.7, height: 720, fps: 24, maxMB: null, audio: true },
  { key: 'social', label: 'Redes 1080p', hint: '1080p · 30 fps', minSec: 1, maxSec: 120, height: 1080, fps: 30, maxMB: null, audio: true },
  { key: 'light', label: 'Liviano 720p', hint: '720p · hasta 20 MB', minSec: 1, maxSec: 120, height: 720, fps: 30, maxMB: 20, audio: true },
];
export const HEIGHTS = [[null, 'Original'], [1080, '1080p'], [720, '720p'], [480, '480p']];
export const FPS = [[30, '30 fps'], [24, '24 fps']];
export const MAX_ADAPT_SECONDS = 120;

export const videoPreset = (key) => VIDEO_PRESETS.find((p) => p.key === key) || null;

/** Bitrate típico (Mbps) que sale con la calidad por defecto, para estimar. */
const TYPICAL_MBPS = { 2160: 16, 1440: 10, 1080: 6, 720: 3, 480: 1.5 };

export function effectiveHeight(sourceH, height) {
  if (!sourceH) return height || null;
  return height ? Math.min(height, sourceH) : sourceH;
}

/** Peso estimado en bytes. Con tope: el tope. */
export function estimateBytes({ seconds, sourceH, height, maxMB, audio }) {
  const s = Math.max(0, Number(seconds) || 0);
  const h = effectiveHeight(sourceH, height) || 1080;
  const near = Object.keys(TYPICAL_MBPS).map(Number).sort((a, b) => Math.abs(a - h) - Math.abs(b - h))[0];
  const bytes = ((TYPICAL_MBPS[near] + (audio ? 0.128 : 0)) * 1e6 / 8) * s;
  return maxMB ? Math.min(bytes, maxMB * 1024 * 1024) : bytes;
}

/** Ancho de salida (manteniendo la proporción, lado par). */
export function outputDims(srcW, srcH, height) {
  if (!srcW || !srcH) return null;
  const h = effectiveHeight(srcH, height);
  const w = Math.round((srcW * h) / srcH / 2) * 2;
  return { width: w, height: h - (h % 2) };
}
